import { isNullOrUndefined } from '../object/null-or-undefined';

/**
 * Map an hour to minutes relative to 00:00
 * @param hour expected to be in format "hh:mm" (24h) or "h:mm AM/PM" (12h)
 */
export const toMinutes = (hour: string) => {
  // tslint:disable: curly
  if (isNullOrUndefined(hour) || isNullOrUndefined(hour.split)) return null;

  // Check if it's AM/PM format (12h)
  const isPM = /pm/i.test(hour);
  const isAM = /am/i.test(hour);

  // Remove AM/PM suffix for parsing
  const cleanHour = hour.replace(/\s*(am|pm)/i, '').trim();

  const [h, m] = cleanHour.split(':').map((comp) => parseInt(comp));
  if (isNullOrUndefined(h) || isNaN(h) || isNullOrUndefined(m) || isNaN(m)) return null;

  let hours = h;

  // Convert 12h to 24h format
  if (isPM && h !== 12) {
    hours = h + 12;
  } else if (isAM && h === 12) {
    hours = 0;
  }

  return (hours % 24) * 60 + m;
};
